export const TethysLocalStorage = 'TethysDataContract';
